import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Store } from '@ngxs/store';
import { TranslateService } from '@ngx-translate/core';
import { filter, map, take } from 'rxjs';

import { BrandState } from '@hiptraveler/data-access/brand';
import { chromaClient, cryptoJsClient, facebookClient, googleMapsClient, googleTagManagerClient, leafletClient, mediumEditorClient, showdownClient } from '@hiptraveler/core/scripts';
import { cryptoJSNamespaceKey, currentLang, filterQueryStringKey, getClientCIdStorage, getLocationData, getWindowRef, globalStateManagementStoreKey, i18nServiceStoreKey, i18nTranslationsKey, leafletNamespaceKey, mediumEditorNamespaceKey, setClientCId, showdownNamespaceKey } from '@hiptraveler/common';

@Injectable()
export class GlobalObjectsService {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private store: Store,
    private i18n: TranslateService
  ) { }

  async initialize(): Promise<void> {

    if (isPlatformServer(this.platformId)) return;

    getWindowRef()[filterQueryStringKey] = getLocationData().search;

    getWindowRef()[i18nServiceStoreKey] = this.i18n;
    getWindowRef()[globalStateManagementStoreKey] = this.store;

    this.i18n.getTranslation(currentLang()).subscribe(translations => {
      getWindowRef()[i18nTranslationsKey] = translations;
    });

    const [ leafletResult, showdownResult, mediumEditorResult, cryptoJSResult ] = await Promise.all([
      leafletClient(), showdownClient(), mediumEditorClient(), cryptoJsClient(),
      chromaClient(), facebookClient(), googleMapsClient(), googleTagManagerClient()
    ]);
    
    getWindowRef()[leafletNamespaceKey] = leafletResult;
    getWindowRef()[showdownNamespaceKey] = showdownResult;
    getWindowRef()[mediumEditorNamespaceKey] = mediumEditorResult;
    getWindowRef()[cryptoJSNamespaceKey] = cryptoJSResult;

    getClientCIdStorage() && setClientCId(getClientCIdStorage());

    this.store.select(BrandState.brandCampaign).pipe(
      map(e => e?.cId),
      filter(Boolean),
      take(12)
    ).subscribe((cId: string) => setClientCId(cId));
  }

}
